import CuentaSelected from "./CuentaSelected";
import FiltrosApi from "./FiltrosApi";

const FormatNumber = {
    separador: ".", // separador para los miles
    sepDecimal: ',', // separador para los decimales
    formatear: function (num) {
        num += '';
        var splitStr = num.split('.');
        var splitLeft = splitStr[0];
        var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        var regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        return this.formatear(num);
    }
}

const GetNameMonth = (code) => {
    const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
        'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    return months[(code - 1)];
}

const getFiltersByAccount = () => {
    const account = CuentaSelected.get();
    const filters = FiltrosApi.get();
    return filters.find(obj => obj.cuentaCodigo === account.cuentaCodigo);
}

const getFullNameEnSuspensions = (code) => {
    let response = code;

    const names = [
        {
            code: 'PO',
            value: 'POSTE',
        },
    ];

    const result = names.find(obj => obj.code === code);
    if (result) {
        response = result.value;
    }
    return response;
};

const getFileExtension = (nameFile) => {
    const ext = nameFile.slice((nameFile.lastIndexOf(".") - 1 >>> 0) + 2);
    return ext.toLowerCase();
};

const validarContrasenaSegura = (contrasenna) => {
    if (contrasenna.length >= 8) {
        let mayuscula = false;
        let minuscula = false;
        let numero = false;

        for (var i = 0; i < contrasenna.length; i++) {
            if (contrasenna.charCodeAt(i) >= 65 && contrasenna.charCodeAt(i) <= 90) {
                mayuscula = true;
            } else if (contrasenna.charCodeAt(i) >= 97 && contrasenna.charCodeAt(i) <= 122) {
                minuscula = true;
            } else if (contrasenna.charCodeAt(i) >= 48 && contrasenna.charCodeAt(i) <= 57) {
                numero = true;
            }
        }

        if (mayuscula === true && minuscula === true && numero === true) {
            return true;
        }
    }
    return false;
}

const getFormData = (params) => {
    let formData = new FormData();
    for (const name in params) {
        formData.append(name, params[name]);
    }
    return formData;
}

export {
    FormatNumber,
    GetNameMonth,
    getFiltersByAccount,
    getFullNameEnSuspensions,
    getFileExtension,
    validarContrasenaSegura,
    getFormData
}